/**
 * Present when the collapsible panel is open.
 */
export const panelOpen = 'data-panel-open';
/**
 * Present when the trigger or the collapsible is disabled.
 */
export const disabled = 'data-disabled';
